import { Component,Input,Output,EventEmitter,SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClickedOutsideDirective } from '../../directives/clicked-outside.directive';

@Component({
  selector: 'app-filter-shared-dropdown',
  imports: [ClickedOutsideDirective,CommonModule],
  templateUrl: './filter-shared-dropdown.html',
  styleUrl: './filter-shared-dropdown.scss'
})
export class FilterSharedDropdown {
  searchIcon = 'assets/img/search.svg';

  @Input() title: string = '';
  @Input() items: any[] = [];
  @Input() selectedItems: any[] = [];
  @Input() showOrgID: boolean = false;
  @Input() customClass: string = '';


  @Input() displayField: string = 'name';
  @Input() secondarydisplayField!: string


  @Output() toggleChange = new EventEmitter<boolean>();
  @Output() itemChecked = new EventEmitter<any>();
  @Output() selectAllChange = new EventEmitter<any>();
  @Output() clearAll = new EventEmitter<void>();
  @Output() selectedItemsChange = new EventEmitter<any[]>();


  searchText: string = '';
  toggle: boolean = false;
  filterList: any[] = []



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] && changes['items'].currentValue) {
      this.filterList = structuredClone(this.items);
    }
  }


  toggleDropdown() {
    this.toggle = !this.toggle;
  }

  closeDropdown() {
    this.toggle = false;
    this.toggleChange.emit(this.toggle);
  }

  onItemChecked(event: Event, item: any, index: number) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.itemChecked.emit({ checked: isChecked, item, index });
  }

  get filteredItems() {
    return this.items.filter(item =>
      item[this.displayField]?.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }


  searchInput(e: Event) {
    const value = (e.target as HTMLInputElement).value;
    if (!value) {
      this.filterList = this.items
      return
    }
    this.filterList = this.items.filter(item =>
      item[this.displayField]?.toLowerCase().includes(value.toLowerCase())
    );
  }

  onClearAll() {
    this.clearAll.emit();
  }
  onSelectAllChanged(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    this.selectAllChange.emit({ checked: isChecked });
  }

  isChecked(id: string) {
    const selectItem = this.selectedItems?.map((item:any)=> item?.[this.displayField] || item?.[this.secondarydisplayField])
    const selectedSet = new Set(selectItem)
    return selectedSet.has(id)
  }


  isAllChecked() {
    const items = this.items ?? [];
    const selected = this.selectedItems ?? [];

    if (items.length === 0 || selected.length === 0) {
      return false;
    }

    const selectedSet = new Set(selected.map(ctrl => ctrl?.[this.displayField] || ctrl?.[this.secondarydisplayField]));
    return items.every(item => selectedSet.has(item[this.displayField] || item[this.secondarydisplayField]));
  }

}
